import { PlatformLocation } from '@angular/common';
var ComponentQuestionnaireHeadPhoto = (function () {
    function ComponentQuestionnaireHeadPhoto(platformLocation) {
        this.platformLocation = platformLocation;
    }
    ComponentQuestionnaireHeadPhoto.prototype.ngOnInit = function () {
        this.origin = this.platformLocation['location']['origin'];
    };
    ComponentQuestionnaireHeadPhoto.prototype.ngAfterViewInit = function () {
    };
    return ComponentQuestionnaireHeadPhoto;
}());
export { ComponentQuestionnaireHeadPhoto };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-photo-head/component.questionnaire-head-photo.ts.pre-build-optimizer.js